import * as constants from 'modules/auth/stateManagement/constants';
import { IGraphAPIConfig, AuthorizationActions } from './actions';
import {
  IGraphAPIConfigState,
  IAuthState,
  GRAPH_API_TOKEN_INITIAL_STATE,
  AUTH_INITIAL_STATE,
  AuthStatus,
} from './state';

export const auth = (
  state: IAuthState = AUTH_INITIAL_STATE,
  action: AuthorizationActions
): IAuthState => {
  switch (action.type) {
    case constants.LOGIN_USER_STARTED: {
      return {
        ...state,
        status: AuthStatus.loading,
      };
    }
    case constants.LOGIN_USER_SUCCESS:
      return {
        ...state,
        status: AuthStatus.authenticated,
        roles: action.payload.roles,
        ssoToken: action.payload.ssoToken,
      };
    case constants.LOGIN_USER_FAILED: {
      return {
        ...state,
        status: AuthStatus.error,
        error: {
          message: action.payload.errorMessage,
          reason: action.payload.reason,
        },
      };
    }
    case constants.AUTHORIZE_USER_STARTED: {
      return {
        ...state,
        b2cStatus: AuthStatus.loading,
      };
    }
    case constants.AUTHORIZE_USER_SUCCESS: {
      return {
        ...state,
        b2cStatus: AuthStatus.authorized,
      };
    }
    case constants.AUTHORIZE_USER_FAILED: {
      return {
        ...state,
        b2cStatus: AuthStatus.error,
        error: {
          message: action.payload.errorMessage,
          reason: action.payload.reason,
        },
      };
    }
    case constants.TOKEN_EXPIRED: {
      return {
        ...state,
        ssoToken: action.payload.ssoToken,
      };
    }
    default:
      return state;
  }
};

export const graphAPIConfigReducer = (
  state: IGraphAPIConfigState = GRAPH_API_TOKEN_INITIAL_STATE,
  action: IGraphAPIConfig
): IGraphAPIConfigState => {
  switch (action.type) {
    case constants.SET_GRAPHAPI_CONFIG:
      return {
        ...state,
        access_token: action.payload,
      };
    default:
      return state;
  }
};
